import { useLang } from "../i18n/LangContext";

const Star = () => (
  <svg viewBox="0 0 24 24" className="mx-8 h-5 w-5 shrink-0 text-noor-gold md:mx-12 md:h-7 md:w-7" aria-hidden>
    <path d="M12 0 C13 8 16 11 24 12 C16 13 13 16 12 24 C11 16 8 13 0 12 C8 11 11 8 12 0Z" fill="currentColor" />
  </svg>
);

export const Marquee = () => {
  const { t, dir } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" aria-hidden className="relative z-[2] overflow-hidden border-y border-noor-champagne/10 py-8 md:py-10" dir="ltr">
      <div className={`marquee-track ${dir === "rtl" ? "marquee-rev" : ""}`}>
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {items.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center" dir={dir}>
                <span className={`whitespace-nowrap font-display text-4xl text-noor-pearl/25 md:text-7xl ${i % 2 ? "italic-accent text-noor-champagne/40" : ""}`}>{w}</span>
                <Star />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
